import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";

declare global {
    interface Window {
        grecaptcha?: {
            getResponse: (widgetId?: number) => string;
            reset: (widgetId?: number) => void;
        };
    }
}

const form = document.getElementById("voxpop-form") as HTMLFormElement | null;
const fileInput = document.getElementById("voxpop-photo-input") as HTMLInputElement | null;
const cropperContainer = document.getElementById("voxpop-cropper-container") as HTMLElement | null;
const cropperImg = document.getElementById("voxpop-cropper-img") as HTMLImageElement | null;

let cropper: Cropper | null = null;
let currentObjectUrl: string | null = null;

function teardownCropper(): void {
    if (cropper) {
        cropper.destroy();
        cropper = null;
    }
    if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = null;
    }
    if (cropperContainer) cropperContainer.hidden = true;
    if (cropperImg) cropperImg.removeAttribute("src");
}

if (fileInput && cropperContainer && cropperImg) {
    fileInput.addEventListener("change", () => {
        const file = fileInput.files?.[0];
        teardownCropper();
        if (!file) return;

        currentObjectUrl = URL.createObjectURL(file);
        cropperImg.src = currentObjectUrl;
        cropperContainer.hidden = false;

        cropper = new Cropper(cropperImg, {
            aspectRatio: 1,
            viewMode: 1,
            autoCropArea: 1,
            background: false,
            movable: false,
            zoomable: true,
            scalable: false,
            rotatable: false,
            responsive: true,
            dragMode: "move",
        });
    });
}

async function getCroppedBlob(): Promise<Blob | null> {
    if (!cropper) return null;
    const canvas = cropper.getCroppedCanvas({
        width: 1200,
        height: 1200,
        imageSmoothingQuality: "high",
    });
    if (!canvas) return null;
    return await new Promise<Blob | null>((resolve) => {
        canvas.toBlob((b) => resolve(b), "image/jpeg", 0.88);
    });
}

if (form) {
    form.addEventListener("submit", async (evt) => {
        evt.preventDefault();

        const submitBtn = form.querySelector<HTMLButtonElement>("button[type=submit]");

        const token = window.grecaptcha?.getResponse() ?? "";
        if (!token) {
            alert("Bekræft venligst at du ikke er en robot.");
            return;
        }

        if (submitBtn) submitBtn.disabled = true;

        try {
            const data = new FormData(form);
            data.set("Recaptcha", token);

            if (cropper) {
                const blob = await getCroppedBlob();
                if (blob) {
                    const originalName = fileInput?.files?.[0]?.name ?? "portrait";
                    const filename = originalName.replace(/\.[^/.]+$/, "") + ".jpg";
                    data.set("Photo", blob, filename);
                }
            }

            const res = await fetch(form.action, { method: "POST", body: data, redirect: "follow" });
            if (res.redirected) {
                window.location.href = res.url;
            } else if (res.ok) {
                window.location.href = "/voxpop/tak";
            } else {
                const text = await res.text();
                alert("Indsendelse fejlede: " + text);
                window.grecaptcha?.reset();
                if (submitBtn) submitBtn.disabled = false;
            }
        } catch (err) {
            console.error(err);
            alert("Indsendelse fejlede. Prøv igen.");
            window.grecaptcha?.reset();
            if (submitBtn) submitBtn.disabled = false;
        }
    });
}

export {};
